import React from 'react';
import { Box, Text, Tip } from 'grommet';
import { IconInfoCircle } from '@tabler/icons-react';
import Icon from '../Icon';
import { useInPanel } from './ChartPanel';

const ChartCard = ({ title, tip, action, children }) => {
    // In a ChartPanel the panel draws the frame and the card is one of its columns
    const frame = useInPanel() ? {} : { round: 'xsmall', border: true, elevation: 'medium', background: 'background', fill: true };
    return (
    <Box pad="medium" gap="medium" {...frame}>
        <Box direction="row" justify="between" align="center" gap="small" wrap>
            {tip ? (
                <Tip
                    content={<Box gap="small" pad="small">{tip}</Box>}
                    dropProps={{ width: { max: 'medium' }, align: { top: 'bottom', left: 'left' } }}
                >
                    <Box direction="row" align="center" gap="xsmall">
                        <Text size="large" weight={500}>{title}</Text>
                        <Icon SelectedIcon={IconInfoCircle} color="text-weak" size="small" />
                    </Box>
                </Tip>
            ) : <Text size="large" weight={500}>{title}</Text>}
            {action}
        </Box>
        {children}
    </Box>
    );
};

export default ChartCard;
